import { render } from "./Admission.vue?vue&type=template&id=0d24c1a5&scoped=true&ts=true"
import script from "./Admission.vue?vue&type=script&lang=ts"
export * from "./Admission.vue?vue&type=script&lang=ts"

import "./Admission.vue?vue&type=style&index=0&id=0d24c1a5&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d24c1a5"]])

export default __exports__